import { Component, ViewChild, OnInit, ElementRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
  AbstractControl,
} from '@angular/forms';
//import { admin_cooler_dropdown_data } from 'src/helper/static';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Observable, SubscriptionLike } from 'rxjs';
import { adminCooler, adminCoolerDropDown } from '../../modals/planogram';
import { PlanogramStateService } from 'src/services/planogram-state.service';
import { environment } from 'src/environments/environment';
import { Papa } from 'ngx-papaparse';

@Component({
  selector: 'app-admin-cooler-panel',
  templateUrl: './admin-cooler-panel.component.html',
  styleUrl: './admin-cooler-panel.component.css',
})
export class AdminCoolerPanelComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('fileInput') fileInputRef!: ElementRef;
  columns = [
    'bottler',
    'unit',
    'channel',
    'caser',
    'cooler_image_uri',
    'internal_dimensions',
    'shelf_1',
    'ss_facings',
  ];
  bottlerData: string[] = [];
  unitData: string[] = [];
  channelData: string[] = [];
  coolerData: string[] = [];
  pageSize: number = 4;
  pageIndex: number = 0;
  start: number = 0;
  end: number = 4;
  dropdown_data_form_group: FormGroup;
  loader: Observable<boolean> = this.planogramState.loader;
  is_show_loader = false;
  selectionSequence = ['bottler', 'unit', 'channel', 'cooler'];
  admin_cooler_dropdown_data_subscription: SubscriptionLike;
  admin_cooler_dropdown_data_observable: Observable<adminCoolerDropDown> =
    this.planogramState.admin_cooler_dropdown_data;
  admin_cooler_dropdown_data: any;
  admin_cooler_data_subscription: SubscriptionLike;
  admin_cooler_data_observable: Observable<adminCooler[]> =
    this.planogramState.admin_cooler_data;
  admin_cooler_data: adminCooler[];
  dataSource = new MatTableDataSource();
  shelves: {} = ['SS', 'LPET', 'HPET', 'OTG'];
  filtered_admin_cooler_data: adminCooler[];

  constructor(
    private _formBuilder: FormBuilder,
    private planogramState: PlanogramStateService,
    private papa: Papa
  ) {
    this.dropdown_data_form_group = this._formBuilder.group({
      bottler: new FormControl({ value: [], disabled: false }),
      unit: new FormControl({ value: [], disabled: false }),
      channel: new FormControl({ value: [], disabled: false }),
      cooler: new FormControl({ value: [], disabled: false }),
    });
    this.planogramState.getAdminCoolerDropDownData();
    this.planogramState.getAdminCoolerData();
  }

  ngOnInit(): void {
    this.admin_cooler_dropdown_data_subscription =
      this.admin_cooler_dropdown_data_observable.subscribe((data) => {
        this.admin_cooler_dropdown_data = data;
      });
    this.admin_cooler_data_subscription =
      this.admin_cooler_data_observable.subscribe((data) => {
        if (data && data.length > 0) {
          this.admin_cooler_data = data;
          this.filtered_admin_cooler_data = data;
          this.getUniqueColumnValues(data, 0);
          this.dataSource.data = data.slice(0, 4);
        }
      });
  }

  getUniqueColumnValues(data: any, index: number) {
    let bottler: { [key: string]: number } = {};
    let unit: { [key: string]: number } = {};
    let channel: { [key: string]: number } = {};
    let cooler: { [key: string]: number } = {};
    data.forEach((v: any) => {
      if (!bottler[v.bottler]) {
        bottler[v.bottler] = 1;
      }
      if (!unit[v.unit]) {
        unit[v.unit] = 1;
      }
      if (!channel[v.channel]) {
        channel[v.channel] = 1;
      }
      if (!cooler[v.caser]) {
        cooler[v.caser] = 1;
      }
    });
    if (index == 0) this.bottlerData = ['All', ...Object.keys(bottler)];
    if (index <= 1) this.unitData = ['All', ...Object.keys(unit)];
    if (index <= 2) this.channelData = ['All', ...Object.keys(channel)];
    if (index <= 3) this.coolerData = ['All', ...Object.keys(cooler)];
    this.setInitialSelection(index);
  }

  setInitialSelection(index:number) {
    let sequence=[this.bottlerData,this.unitData,this.channelData,this.coolerData]
    this.selectionSequence.forEach((dropdown,i)=>{
      if(index==0 || (i>=index && i<this.selectionSequence.length))
        this.dropdown_data_form_group.controls[dropdown]?.setValue(
        sequence[i]
      );
    })
  }

  paginationChange(pageEvt: PageEvent) {
    this.start = pageEvt.pageIndex * this.pageSize;
    this.end = this.start + this.pageSize;
    this.pageIndex = pageEvt.pageIndex;
    this.dataSource.data = this.filtered_admin_cooler_data.slice(
      this.start,
      this.end
    );
  }

  openInputForUpload(): void {
    this.fileInputRef.nativeElement.click();
  }

  uploadCsv(event: any) {
    const file: File = event.target.files[0];
    const formData = new FormData();
    formData.append('file', file);
    this.planogramState.uploadAdminCooler(formData);
  }

  toggleSelection(name:string ,formName:string,index:number){
    let sequence=[this.bottlerData,this.unitData,this.channelData,this.coolerData];
    if(name=="All" && !this.dropdown_data_form_group.controls[formName]?.value.includes("All")){
      this.dropdown_data_form_group.controls[formName]?.setValue([]);
    }
    else if (
      name=="All" && this.dropdown_data_form_group.controls[formName].value.includes('All')
    ) {
      this.selectionSequence.forEach((v, i) => {
        if (i >= index && i < this.selectionSequence.length) {
              this.dropdown_data_form_group.controls[v]?.setValue(sequence[i]);
        }
      });
    }
    else {
      
      if(!this.dropdown_data_form_group.controls[formName].value.includes(name) && this.dropdown_data_form_group.controls[formName].value.includes("All")){
        this.dropdown_data_form_group.controls[formName]?.setValue(sequence[index].filter((v:any)=>v!=="All" && v!==name));
      }
      this.selectionSequence.forEach((v, i) => {
       if (i > index && i < this.selectionSequence.length) {
             this.dropdown_data_form_group.controls[v]?.setValue(sequence[i]);
       }
     });
   }
   this.onfilterChange(index,formName)
  }

  onfilterChange(index: number, formName: string) {
    let selectedBottler =
      this.dropdown_data_form_group.controls['bottler'].value;
    let selectedUnit = this.dropdown_data_form_group.controls['unit'].value;
    let selectedChannel =
      this.dropdown_data_form_group.controls['channel'].value;
    let selectedCooler = this.dropdown_data_form_group.controls['cooler'].value;
    if (formName == 'bottler' && selectedBottler.includes('All')) {
      this.filtered_admin_cooler_data = this.admin_cooler_data;
      this.dataSource.data = this.filtered_admin_cooler_data.slice(0, 4);
      this.getUniqueColumnValues(this.filtered_admin_cooler_data, 0);
    } else {
      this.filtered_admin_cooler_data = this.admin_cooler_data.filter(
        (v) =>
          ((!selectedBottler.includes('All') && selectedBottler.length!==0)
            ? selectedBottler.includes(v['bottler'])
            : true) &&
          ((!selectedUnit.includes('All') &&  selectedUnit.length!==0)
            ? selectedUnit.includes(v['unit'])
            : true) &&
          ((!selectedChannel.includes('All') && selectedChannel.length!==0)
            ? selectedChannel.includes(v['channel'])
            : true) &&
          ((!selectedCooler.includes('All') && selectedCooler.length!==0 )
            ? selectedCooler.includes(v['caser'])
            : true)
      );
      this.dataSource.data = this.filtered_admin_cooler_data.slice(0, 4);
      this.getUniqueColumnValues(this.filtered_admin_cooler_data, index + 1);
    }
    this.pageIndex = 0;
    this.start = 0;
    this.end = 4;
  }

  calculateTotalShelves(
    shelf1: string,
    shelf2: string,
    shef3: string,
    shelf4: string,
    shelf5: string,
    shelf6: string
  ) {
    let shelves_obj: { [key: string]: number } = {};
    let shelvesString =
      shelf1 +
      ',' +
      shelf2 +
      ',' +
      shef3 +
      ',' +
      shelf4 +
      ',' +
      shelf5 +
      ',' +
      shelf6;
    let givenShelves = shelvesString.split(',');
    givenShelves.forEach((s) => {
      if (s !== '0') {
        if (shelves_obj[s]) {
          shelves_obj[s] = shelves_obj[s] + 1;
        } else {
          shelves_obj[s] = 1;
        }
      }
    });
    let total = Object.values(shelves_obj).reduce((a, b) => a + b);
    let total_string = 'Total:' + total;
    let SS = shelves_obj['SS'] ? 'SS:' + shelves_obj['SS'] : '';
    let OTG = shelves_obj['OTG'] ? 'OTG:' + shelves_obj['OTG'] : '';
    let HPET = shelves_obj['HPET'] ? 'HPET:' + shelves_obj['HPET'] : '';
    let LPET = shelves_obj['LPET'] ? 'LPET' + shelves_obj['LPET'] : '';
    return `${total_string}\n ${SS}\n ${OTG}\n ${HPET}\n ${LPET}\n`;
  }

  downloadCoolerData(filename = 'data') {
    let headers:string[] = Object.keys(this.admin_cooler_data[0]);
    headers=headers.filter(v=>v!="id")
    let data: any = this.admin_cooler_data;
    // let csvData = this.ConvertToCSV(data, headers);
    let config={columns:headers}
    let result = this.papa.unparse(data,config);
    let blob = new Blob(['\ufeff' + result], {
      type: 'text/csv;charset=utf-8;',
    });
    let dwldLink = document.createElement('a');
    let url = URL.createObjectURL(blob);
    let isSafariBrowser =
      navigator.userAgent.indexOf('Safari') != -1 &&
      navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {
      //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute('target', '_blank');
    }
    dwldLink.setAttribute('href', url);
    dwldLink.setAttribute('download', filename + '.csv');
    dwldLink.style.visibility = 'hidden';
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  // ConvertToCSV(data: adminCooler[], headers: string[]) {
  //   let array = typeof data != 'object' ? JSON.parse(data) : data;
  //   let str = '';
  //   let row = 'S.No,';
  //   headers = headers.filter((v) => v !== 'id');
  //   headers.unshift('id');
  //   for (let index in headers) {
  //     row += headers[index] + ',';
  //   }
  //   row = row.slice(0, -1);
  //   str += row + '\r\n';
  //   for (let i = 0; i < array.length; i++) {
  //     let line = i + 1 + '';
  //     for (let index in headers) {
  //       let head = headers[index];
        
  //       line += ',' + array[i][head];
  //     }
  //     str += line + '\r\n';
  //   }
  //   return str;
  // }
}
